export default __webpack_public_path__ + "static/media/blueCancel.82e493cd.svg";